import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ maxWidth: "900px", margin: "40px auto", padding: "20px", lineHeight: "1.6", fontFamily: "Arial" }}>
      
      <h1>Privacy Policy – Pitics</h1>
      <p><strong>Effective Date:</strong> March 2026</p>

      <p>
        Pitics ("we", "our", or "us") operates the Pitics mobile application and website. 
        Pitics is an e-commerce platform that allows users to design and purchase 
        personalized stationery products such as labels, pencil boxes, notebooks, 
        wraps, and other customized items.
      </p>

      <p>
        This Privacy Policy explains how we collect, use, store, and protect your 
        information when you use our services.
      </p>

      <h2>1. Information We Collect</h2>
      <p>We collect information to provide better services and improve user experience.</p>

      <h3>1.1 Account Information</h3>
      <p>
        When you sign in to Pitics using Google Sign-In, we may collect:
      </p>
      <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>Google account identifier</li>
        <li>Profile photo (if available)</li>
      </ul>

      <p>This information is used only to create and manage your Pitics account.</p>

      <h3>1.2 Order Information</h3>
      <p>When you place an order, we may collect:</p>
      <ul>
        <li>Shipping address</li>
        <li>Phone number</li>
        <li>Order details</li>
        <li>Personalized product information such as text, photos, or design selections</li>
      </ul>

      <h3>1.3 Payment Information</h3>
      <p>
        Payments in Pitics are processed through secure third-party payment providers 
        such as Razorpay. Pitics does not store your credit card, debit card, or 
        banking information. Payment providers handle this data according to their 
        own privacy policies.
      </p>

      <h3>1.4 Automatically Collected Information</h3>
      <p>When you use the Pitics app, certain information may be collected automatically:</p>
      <ul>
        <li>Device type</li>
        <li>Operating system</li>
        <li>App version</li>
        <li>Usage statistics</li>
        <li>IP address</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>Create and manage your account</li>
        <li>Process orders and payments</li>
        <li>Deliver purchased products</li>
        <li>Provide customer support</li>
        <li>Improve app functionality and performance</li>
        <li>Prevent fraud and misuse</li>
        <li>Send order updates and service notifications</li>
      </ul>

      <p>We do not sell your personal data to third parties.</p>

      <h2>3. Data Storage and Security</h2>
      <p>
        Your data may be stored using secure cloud services such as Firebase 
        Authentication, Firebase Firestore, and Google Cloud services.
      </p>

      <p>
        We implement reasonable security measures to protect your information 
        from unauthorized access, alteration, disclosure, or destruction. 
        All data transmissions are encrypted using HTTPS.
      </p>

      <h2>4. Data Sharing</h2>
      <p>We may share limited information with trusted third parties when necessary:</p>
      <ul>
        <li>Payment providers (for payment processing)</li>
        <li>Delivery and logistics partners (for order fulfillment)</li>
        <li>Cloud service providers (for secure data storage)</li>
      </ul>

      <h2>5. Children's Privacy</h2>
      <p>
        Pitics services are not intended for children under the age of 13. 
        We do not knowingly collect personal information from children without 
        parental consent.
      </p>

      <h2>6. User Rights and Data Deletion</h2>
      <p>
        Users may request access, correction, or deletion of their account 
        and associated data.
      </p>

      <p>
        To request account deletion or data removal, please contact us at:
      </p>

      <p><strong>Email:</strong> support@pitics.com</p>

      <h2>7. Third-Party Services</h2>
      <p>Pitics may use third-party services including:</p>
      <ul>
        <li>Google Sign-In</li>
        <li>Firebase services</li>
        <li>Razorpay payment processing</li>
      </ul>

      <h2>8. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Updated versions 
        will be posted on this page with the revised effective date.
      </p>

      <h2>9. Contact Us</h2>
      <p>If you have questions about this Privacy Policy:</p>

      <p>
        Email: support@pitics.com <br />
        Website: https://pitics.com
      </p>

    </div>
  );
};

export default PrivacyPolicy;